
import { computed, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import {
  CustomerShareCampaign,
  ShareCampaignParsed,
  ShareCampaignSettings,
  useShareCampaign,
} from '@/compositions/useShareCampaign';
import DialogQRCodeReader from '@/components/organisms/DialogQRCodeReader.vue';
import ComsbiSaasScheme from '@comsbi/common/src/libs/comsbi-saas-scheme';
import ShareCampaignPageContents from '@/components/organisms/share_campaign/ShareCampaignPageContents.vue';
import { shareMessageContent } from '@comsbi/common/src/contents/shareCampaignMessage';
import liff from '@line/liff';
// import { SendMessagesParams } from '@liff/send-messages';
import { useRoute, useRouter } from 'vue-router/composables';
import { ToastProgrammatic as Toast } from 'buefy';

const { VUE_APP_APP_ENDPOINT } = process.env;
const CHANNEL_ID =
  process.env.NODE_ENV === 'local' ? window.CHANNEL_ID || process.env.VUE_APP_CHANNEL_ID : window.CHANNEL_ID;

export default defineComponent({
  name: 'PagesShareCampaign',

  components: { ShareCampaignPageContents, DialogQRCodeReader },

  setup(_) {
    const { resolve, stamp } = useShareCampaign();
    const route = useRoute();
    const router = useRouter();

    const state = reactive<{ id: string; campaign: CustomerShareCampaign | null; gotStamp: boolean; loading: boolean }>(
      {
        id: route.params.id,
        campaign: null,
        gotStamp: false,
        loading: false,
      }
    );

    const master = computed<ShareCampaignParsed | null>(() => (state.campaign ? state.campaign.shareCampaign : null));

    const _loadContents = async () => {
      state.campaign = (await resolve(state.id)).result || null;
    };

    onMounted(async () => {
      await _loadContents();
    });

    const share = async () => {
      //
      // LIFF
      const contents = master.value?.settings.shareMessageContents ?? {};
      const result = await liff.shareTargetPicker(
        [
          shareMessageContent(
            `${VUE_APP_APP_ENDPOINT}/${CHANNEL_ID}/share_campaign/${state.campaign?.id}`,
            contents.text,
            contents.image,
            contents.buttonLabel
          ).content,
        ] as any, // CS-9002 パッケージ重複? liffId is necessary for liff.init() 対応
        {
          isMultiple: true,
        }
      );
      if (!result) return; // CS-7674

      result.status;

      Toast.open({
        message: 'シェアメッセージを送りました。',
        type: 'is-success',
        position: 'is-top',
      });
    };

    watch(
      () => route,
      async (to, from) => {
        // パス更新
        state.id = to.params.id;
        await _loadContents();
      }
    );

    return {
      state,
      master,

      share,

      // debug
      router: { ...router },
    };
  },
});
